/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PatchedCreatePepCheckRequest {
  user?: string;
  added_by?: string | null;
  comment?: string;
  status?: string;
}
